

export enum KalturaContributionPolicyType {
    all=1,
	membersWithContributionPermission=2
}